const NUMERIC_PHOTO_NAME_PATTERN = /^(\d+)\.(jpe?g|png)$/i;

export function getNumericBaseName(fileName: string): string | null {
  const trimmed = fileName.trim();
  const match = trimmed.match(NUMERIC_PHOTO_NAME_PATTERN);
  return match ? match[1] : null;
}

export function isValidNumericPhotoFileName(fileName: string): boolean {
  return getNumericBaseName(fileName) !== null;
}

export function findFirstInvalidNumericPhotoFile(
  files: readonly File[]
): File | undefined {
  return files.find((file) => !isValidNumericPhotoFileName(file.name));
}

export function compareNumericPhotoFileNames(a: File, b: File): number {
  const baseA = getNumericBaseName(a.name);
  const baseB = getNumericBaseName(b.name);
  if (baseA == null && baseB == null) return a.name.localeCompare(b.name);
  if (baseA == null) return 1;
  if (baseB == null) return -1;
  return Number(baseA) - Number(baseB);
}

export function sortFilesByNumericPhotoName(files: readonly File[]): File[] {
  return [...files].sort(compareNumericPhotoFileNames);
}

export function invalidNumericPhotoFileMessage(fileName: string): string {
  return `O arquivo "${fileName}" é inválido: o nome (sem extensão) deve conter apenas dígitos, por exemplo 123.jpg ou 456.png.`;
}
